import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function EsModule() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Es Module</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Es Module è un altro sistema di utiizzo dei moduli contenenti le funzioni JavaScript all'interno del nostro progetto Node.js
                            </h5>
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Common JS VS Es Module</h2>
                            
                            {/* Inizio schema Node JS */}
                            <p className="description" style={{color: 'black'}}>
                                Node JS → usa Common.js → require → sincrono
                                <br />
                                {/* Schema Require */}
                                <p className="description text-left" style={{color: 'black'}}>
                                    Utilizzando <strong>Require</strong>:
                                    <br />- blocco il servizio (sincorno)
                                    <br />- posso inserirlo dove voglio all’interno del codice
                                    <br />- sono obbligato a importare tutto il modulo
                                </p>
                            </p>
                            {/* Fine schema Node JS */}

                            {/* Inizio schema React JS */}
                            <p className="description" style={{color: 'black'}}>
                                React JS → usa Es Module → import → asincrono
                                <br />
                                {/* Schema Import */}
                                <p className="description text-left" style={{color: 'black'}}>
                                    Utilizzando <strong>Import</strong>:
                                    <br />- non blocco il servizio (asincrono)
                                    <br />- deve essere sempre importarlo all’inizio del file
                                    <br />- con import posso fare la destrutturazione
                                </p>
                            </p>
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>


            {/* INIZIO CODICE JSON - package.json */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
            language="javascript"
            description="Per creare il file 'package.json' è sufficente digitare nel terminale il comando 'npm init' e completare le informazioni successive richieste. Nel mio caso lascio come nome il nome della cartella
            (1) lascio come versione 1.0.0
            (2) posso inserire una descrizione
            (3) inserisco come “main” “server.js”
            (4) il resto lascio tutto vuoto
            (5) confermo con “yes”
            N.B. Dopo aver generato il file 'package.json' è necessario andare ad aggiungere il tipo (type) dichiarandolo come modulo (riga 4)"
            code={`{
    "name": "es_module",
    "version": "1.0.0",
    "description": "package del mio primo progetto",
    "type": "module",
    "main": "server.js",
    "scripts": {
        "test": "echo \"Error: no test specified\" && exit 1",
        "start": "node server.js"
    },
    "author": "Mattia Bracco",
    "license": "ISC"
}`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JSON - package.js */}

            {/* INIZIO CODICE JAVASCRIPT - modulo.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
            language="javascript"
            description="Anche in questo caso vadoa creare il mio modulo (file modulo.js), questa volta per esportarlo utilizzo il comando 'export' inserito prima della funzione dichiarata con 'const'"
            code={`//let pippo = 0 //Variabile locale al modulo

//Funzione SOMMA
export const somma=(num1, num2) => {
    let totale = num1 + num2
    return (totale)
}

//Funzione DIFFERENZA
export const differenza=(num1, num2) => {
    let totale = num1 - num2
    return (totale)
}

/*
Per esportare le mie funzioni inserisco "export" prima di "const" dove dichiaro le funzioni
*/`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JAVASCRIPT - modulo.js */}

            {/* INIZIO CODICE JAVASCRIPT - server.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Come si può vedere il codice del file 'server.js' è molto simile a quello utilizzato con Common.js, qui si può notare che viene utilizzato il comando import anzichè require"
                code={`import http from "http"

/*
Posso importare le funzioni che solo mi servono elencandole nelle "{}"
Questo si chiama "destrutturazione"
*/

import {somma, differenza} from "./modulo.js"

/*
Nel file "package.json" alla riga 5 dichiaro come "type" "module"
Questo non deve esseredichiarato nello script! ma prima (per esempio dopo la descrizione (description))
*/

http.createServer((req, res) => {

    res.end(somma(5,7).toString())

}).listen(3000)`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JAVASCRIPT - server.js */}

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/es_module" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}
            
        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default EsModule;
